module.exports = __webpack_public_path__ + "static/media/mu.896330b7.svg";